import { Icon } from '@99designs/common/components/Icon';
import { StructuredBriefFile } from '__generated__/StructuredBriefFile';
import { Matrix, MatrixItem } from 'common/components/Matrix';
import Mediabox from 'launch/components/Mediabox';
import React from 'react';

const Attachments = (attachments: StructuredBriefFile[]) => {
    return (
        <Matrix large={3}>
            {attachments.map((attachment, id) => {
                return (
                    <MatrixItem key={id}>
                        <Mediabox>
                            <div className="uploader-attachment-overlay">
                                <div className="uploader-attachment-overlay__inner">
                                    <div className="uploader-attachment-overlay__content">
                                        {attachment.previewable ? (
                                            <img
                                                src={`https://${
                                                    attachment.bucket
                                                }.s3-accelerate.amazonaws.com/${attachment.key}`}
                                            />
                                        ) : (
                                            <Icon type={'document-1'} variations={['2x']} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Mediabox>
                    </MatrixItem>
                );
            })}
        </Matrix>
    );
};

export default Attachments;
